

























import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../../mixins";
import { FormatQuestionnairePropertyEditor } from "./contents";

@Component({
  components: {
    FormatQuestionnairePropertyEditor,
  },
})
export default class FormatPropertyQuestionnaireEditTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  private readonly fillText = "       ";
  editingNameFirst: string = null;
  editingNameSecond: string = null;
  editingNameThird: string = null;

  get questionnaireName(): string {
    return this.masterCode ? this.masterCode : "";
  }

  get nameFirst(): string {
    this.editingNameFirst = this.questionnaireName.slice(0, 7).trim();
    return this.editingNameFirst;
  }

  set nameFirst(value: string) {
    this.editingNameFirst = value.trim();
    this.updateQuestionnaireName();
  }

  get nameSecond(): string {
    this.editingNameSecond = this.questionnaireName.slice(7, 13).trim();
    return this.editingNameSecond;
  }

  set nameSecond(value: string) {
    this.editingNameSecond = value.trim();
    this.updateQuestionnaireName();
  }

  get nameThird(): string {
    this.editingNameThird = this.questionnaireName.slice(13, 15).trim();
    return this.editingNameThird;
  }

  set nameThird(value: string) {
    this.editingNameThird = value.trim();
    this.updateQuestionnaireName();
  }

  private updateQuestionnaireName() {
    const text = this.adjustText(this.editingNameFirst, 7) + this.adjustText(this.editingNameSecond, 6) + this.adjustText(this.editingNameThird, 2);
    if (this.masterCode !== text) {
      this.masterCode = text;
    }
  }

  private adjustText(text: string, length: number): string {
    return (text + this.fillText).slice(0, length);
  }
}
